
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { M4A_TO_TEXT_PAGE } from '@/components/transcription-landing/landingPages';
import TranscriptionLanding from '@/components/transcription-landing/TranscriptionLanding';
export default function M4aToTextPage() {
    return <TranscriptionLanding page={M4A_TO_TEXT_PAGE}/>;
}

    async function __Next_Translate__getStaticProps__1a120fdf9f2__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/ai-transcription/m4a-to-text-converter',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a120fdf9f2__ as getStaticProps }
  